module.exports = __webpack_public_path__ + "static/media/hohepa-logo-white.938c6728.png";